import FormErrors from "@/components/FormErrors/FormErrors";
import { JSConn } from "@/utilities/js-conn";
import uuidv4 from "uuid/v4";
import { last as Rlast } from "ramda";
import HmAutocompleteObject from "@/components/Autocomplete/AutocompleteObject.vue";

export default {
  name: "templateWorkOrderLotEditForm",
  props: {
    templateWorkOrderLotId: String,
  },
  components: {
    FormErrors,
    HmAutocompleteObject,
  },
  data() {
    return {
      hasLotErrors: false,
      lotErrors: [],
      lot: {
        id: "",
        description: "",
        template_description: "",
        sort_order: 200,
        lot_unit_id: null,
        lot_unit: {},
      },
    };
  },
  created() {
    // find all the lots for this work order
    // they should be in the store
    const STEP_SIZE = 200;
    let lastLot = Rlast(this.templateWorkOrderLots);

    // for the situations when there isn't a last lot
    if (!lastLot) {
      lastLot = {
        sort_order: 0,
      };
    }

    if (this.templateWorkOrderLotId === "new") {
      this.lot = {
        id: uuidv4(),
        description: "New",
        sort_order: lastLot.sort_order + STEP_SIZE,
        template_work_order_id: this.templateWorkOrder.id,
        template_description: "new",
        lot_unit_id: null,
        lot_unit: {},
      };
    } else {
      // load the lot into the store
      // or retrieve it
      const woLot = this.templateWorkOrderLotById(this.templateWorkOrderLotId);
      const lotUnit = this.lotUnitById(woLot.lot_unit_id);
      this.lot = {
        id: woLot.id,
        description: woLot.description,
        template_description: woLot.description,
        sort_order: woLot.sort_order,
        lot_unit_id: woLot.lot_unit_id,
        lot_unit: {
          text: lotUnit.description,
          value: lotUnit.id,
        },
      };
    }

    this.$nextTick(() => this.$refs.firstInput.select());
  },
  computed: {
    templateWorkOrder: function() {
      return this.$store.getters.templateWorkOrder;
    },
    templateWorkOrderLots: function() {
      return this.$store.getters.templateWorkOrderLots;
    },
    templateWorkOrderLotById: function() {
      return id => this.$store.getters.templateWorkOrderLotById(id);
    },
    lotUnitById: function() {
      return id => this.$store.getters.lotUnitById(id);
    },
    lotUnitsForAutocomplete: function() {
      return this.$store.getters.lotUnitsForAutocomplete;
    },
  },
  methods: {
    submitLotForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();

      let storeDispatch;

      if (this.templateWorkOrderLotId === "new") {
        storeDispatch = "createTemplateWorkOrderLot";
      } else {
        storeDispatch = "updateTemplateWorkOrderLot";
      }

      // template description is not being used
      // but set it any way.
      this.lot.template_description = this.lot.description;

      jsConn.formParams = this.lot;

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(() => {
          // move to the list of lots
          this.$router.push({
            name: "templateWorkOrderLots",
          });
          this.$emit("templateLotsChanged");
        })
        .catch(jsConn => {
          this.hasLotErrors = true;
          this.lotErrors = jsConn.error["response"]["data"];
        });
    },
    updateLotUnit(evt) {
      this.lot.lot_unit = evt;
      this.lot.lot_unit_id = evt.value;
    },
  },
};
